import Chip from '@material-ui/core/Chip/Chip';
import React from 'react';
import Avatar from '@material-ui/core/Avatar';

const getAvatar = (type) => {
  switch (type) {
    case 'staza':
      return (<Avatar src="/apple-icon-114x114.png" />);
    default:
      return (<Avatar src="/images/icons/barcode.png" />);
  }
}

const Identifier = ({ identifier }) => {
  return (<Chip
    key={identifier.id}
    label={identifier.identifier}
    avatar={getAvatar(identifier.type.code)}
    color="secondary"
  />);
}

export default Identifier;


// WEBPACK FOOTER //
// ./src/components/Common/Identifier/index.js